import React from 'react';
import Destination from '../Destination/Destination';

import HeroBanner from '../HeroBanner/HeroBanner';


import Testimonial from '../Testimonial/Testimonial';

const Home = () => {
    return (
        <>
            <HeroBanner></HeroBanner>

            <Destination></Destination>


            <Testimonial></Testimonial>
        </>
    );
};

export default Home;